import api from '@/api'

const store = {
  state: {
    dataOutletPrice: [],
    outletPriceConfig: {},
    pagingOutletPrice: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingOutletPrice: {
      byField: '',
      isDesc: false
    },
    filteringOutletPrice: {
      outletCode: null,
      orderType: null,
      priceType: null
    }
  },

  mutations: {
    SET_OUTLETPRICE: (state, payload) => {
      state.dataOutletPrice = payload
    },
    SET_OUTLET_PRICE_CONFIG: (state, payload) => {
      state.outletPriceConfig = payload
    },
    SET_PAGING_PAGE_OUTLETPRICE: (state, payload) => {
      state.pagingOutletPrice.page = payload
    },
    SET_PAGING_TOTAL_OUTLETPRICE: (state, payload) => {
      state.pagingOutletPrice.total = payload
    },
    SET_SORTING_OUTLETPRICE: (state, payload) => {
      state.sortingOutletPrice = payload
    },
    SET_FILTERING_OUTLETPRICE: (state, payload) => {
      state.filteringOutletPrice = payload
    }
  },

  getters: {
    SortingOutletPrice: state => state.sortingOutletPrice,
    FilteringOutletPrice: state => state.filteringOutletPrice,
    PagingOutletPrice: state => state.pagingOutletPrice,
    GetAllOutletPrice: state => state.dataOutletPrice,
    GetOneOutletPrice: state => id =>
      state.dataOutletPrice.find(dataOutletPrice => dataOutletPrice.id === id),
    GetOutletPriceConfig: state => state.outletPriceConfig
  },

  actions: {
    async UpdateSortingOutletPrice({ commit, dispatch }, payload) {
      commit('SET_SORTING_OUTLETPRICE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllOutletPrice')
    },

    async UpdateFilteringOutletPrice({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_OUTLETPRICE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_OUTLETPRICE', 1)
      dispatch('GetAllOutletPrice')
    },

    async GetAllOutletPrice({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllOutletPrice(
          state.pagingOutletPrice,
          state.sortingOutletPrice,
          state.filteringOutletPrice
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_OUTLETPRICE', result.headers['data-length'])
        commit('SET_OUTLETPRICE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateOutletPrice({ dispatch }, payload) {
      try {
        const { data } = await api.CreateOutletPrice(payload)
        dispatch('GetAllOutletPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateOutletPrice({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateOutletPrice(payload.id, payload)
        dispatch('GetAllOutletPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteOutletPrice({ dispatch }, id) {
      try {
        const { data } = await api.DeleteOutletPrice(id)
        dispatch('GetAllOutletPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async GetOutletPriceConfig({ commit }) {
      try {
        const { data } = await api.GetOutletPriceConfig()
        commit('SET_OUTLET_PRICE_CONFIG', data.result)
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}
export default store
